import { render, staticRenderFns } from "./CompanyStep.vue?vue&type=template&id=0b07c296&"
import script from "./CompanyStep.vue?vue&type=script&lang=js&"
export * from "./CompanyStep.vue?vue&type=script&lang=js&"
import style0 from "./CompanyStep.vue?vue&type=style&index=0&id=0b07c296&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports